import { render, staticRenderFns } from "./recommends.vue?vue&type=template&id=5a109ee4&scoped=true&"
import script from "./recommends.vue?vue&type=script&lang=js&"
export * from "./recommends.vue?vue&type=script&lang=js&"
import style0 from "./recommends.vue?vue&type=style&index=0&id=5a109ee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a109ee4",
  null
  
)

export default component.exports